var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Campaigns = MDB.DPN.Campaigns || {};

(function() {	
	var _config;

	var controllerBaseUrl = '/Campaigns/', 
	apiBaseUrl = '/api/Campaigns/',
	annotationUrl = apiBaseUrl + 'GetAnnotations/';

	var _annotationType = {
		delivery: 'Delivery',
		change: 'Change',
		attention: 'Attention',
		propositionChange: 'PropositionChange'
	};

	var _requestState = {
	    conceptCampaign: 0,
	    pendingCampaign: 1,
	    activeCampaign: 2,
	    expiredCampaign: 3
	};

	var _modelState = {
		concept: 0,
		active: 1,
		draft: 2
	};

	var _editorState;

	var _grids,
	_editor,
	_modal,
	_kendo;

	function _loadPendingTooltips () {
		MDB.DPN.Campaigns.loadGridTooltips (_grids.pendingGrid, 
				['[data-action="campaign-details"]','[data-action="annotation-add"]'], 
				['Dpn_CampaignManager_Details_Button_Tooltip','Dpn_CampaignManager_Annotation_Button_Tooltip']);
	}

	function _loadConceptTooltips () {
		MDB.DPN.Campaigns.loadGridTooltips (_grids.conceptGrid, 
				['[data-action="campaign-delete"]','[data-action="campaign-edit"]','[data-action="annotation-add"]'], 
				['Dpn_CampaignManager_Delete_Button_Tooltip','Dpn_CampaignManager_Edit_Button_Tooltip','Dpn_CampaignManager_Annotation_Button_Tooltip']);
	}
	
	function _loadActiveTooltips () {
		MDB.DPN.Campaigns.loadGridTooltips (_grids.activeGrid, 
				['[data-action="annotation-add"]','[data-action="campaign-dashboard"]','[data-action="campaign-details"]','[data-action="campaign-rapport"]'], 
				['Dpn_CampaignManager_Annotation_Button_Tooltip','Dpn_CampaignManager_Dashboard_Button_Tooltip',
				'Dpn_CampaignManager_Details_Button_Tooltip','Dpn_CampaignManager_Pdf_Button_Tooltip']);
	}
	
	function _loadExpiredTooltips () {
		MDB.DPN.Campaigns.loadGridTooltips (_grids.expiredGrid, 
				['[data-action="annotation-add"]','[data-action="campaign-dashboard"]','[data-action="campaign-details"]','[data-action="campaign-rapport"]'], 
				['Dpn_CampaignManager_Annotation_Button_Tooltip','Dpn_CampaignManager_Dashboard_Button_Tooltip',
				'Dpn_CampaignManager_Details_Button_Tooltip','Dpn_CampaignManager_Pdf_Button_Tooltip']);
	}

	function initGrids() {
		var url = apiBaseUrl + 'Get?state=';

		MDB.DPN.Campaigns.initCampaignGrid(_grids.conceptGrid, url, _requestState.conceptCampaign).done(function () {
			 _loadConceptTooltips(); 
			});

		MDB.DPN.Campaigns.initCampaignGrid(_grids.pendingGrid, url, _requestState.pendingCampaign).done(function () {
			 _loadPendingTooltips(); 
			});

		MDB.DPN.Campaigns.initCampaignGrid(_grids.activeGrid, url, _requestState.activeCampaign).done(function () { 
			_loadActiveTooltips(); 
		});

		MDB.DPN.Campaigns.initCampaignGrid(_grids.expiredGrid, url, _requestState.expiredCampaign).done(function () { 
			_loadExpiredTooltips();
		});

		MDB.DPN.Campaigns.initCampaignGrid(_grids.annotationsGrid, annotationUrl, null, true);

		_kendo = {
			conceptGrid: MDB.KendoConfigBuilder.getKendoWidget(_grids.conceptGrid),
			pendingGrid: MDB.KendoConfigBuilder.getKendoWidget(_grids.pendingGrid),
			activeGrid: MDB.KendoConfigBuilder.getKendoWidget(_grids.activeGrid),
			expiredGrid: MDB.KendoConfigBuilder.getKendoWidget(_grids.expiredGrid),
			annotationsGrid: MDB.KendoConfigBuilder.getKendoWidget(_grids.annotationsGrid)
		};
	}

	function clearForm(form) {
		form.find('input,textarea').not('#State,#StartValue,[role="listbox"],#Id').val('');
		form.find('.k-multiselect-wrap').find('.k-delete').click();
	}

	function handleAjaxResponse(response, form, successMessage) {
		if(response.errors.length > 0) {
			MDB.Notify.bootstrapDanger(response.errors.join('<br />'));
		} else {
			MDB.Notify.bootstrapSuccess(successMessage);
			clearForm(form);
		}
	}

	$.extend(MDB.DPN.Campaigns, {
		boot: function(config) {			
			_config = config;
			_editorState = MDB.DPN.Campaigns.Editor.states();

			_grids = {
				conceptGrid: $('#concept-campaigns-grid'),
				pendingGrid: $('#pending-campaigns-grid'),
				activeGrid: $('#active-campaigns-grid'),
				expiredGrid: $('#expired-campaigns-grid'),
				annotationsGrid: $('#annotations-grid')
			};

			_editor = $('#editor-modal');
			_modal = _editor.find('.modal-content');

			MDB.DPN.Campaigns.Editor.init((_config.editorTypes));
			MDB.DPN.Campaigns.initCampaignEditor($('#new-campaign'));

			MDB.DPN.Campaigns.initWidgets();

			initGrids();

            $('#add-annotation').click(function (e) {
				MDB.DPN.Campaigns.campaignAnnotationClick();
			});

			MDB.initBootstrapSwitchesDependantControls($('.enable-switch'));

			$(document).ready(function () {
				$('#new-campaign').find('form').data('validator').settings.ignore = "";
			});
		},
		bootPlanning: function(config){
			_config = config;

			var defaultDateRange = MDB.DPN.Campaigns.getDefaultDateRange();
			
			MDB.DPN.Campaigns.initCampaignGrid($('#annotations-grid'), annotationUrl, null, true);
			
			MDB.Charts.initDashboardFilters();
			MDB.Charts.setupDatePicker('#datepicker', {
				parent: '#filters',
				sessionStartDate: moment(defaultDateRange.startDate).format(MDB.Charts.dateFilterInputFormat),
				sessionEndDate: moment(defaultDateRange.endDate).format(MDB.Charts.dateFilterInputFormat),
				defaultDateRangeFilter: undefined,
				ignoreCache: true,
				unlockedRange: true
			});
			
			MDB.DPN.Campaigns.initWidgets({
				totalsConfig: {
					// url: apiBaseUrl + 'Totals'
				},
				timelineConfig: {
					getSeriesLabelHoverBody: function(e){
						var dataItem = e.dataItem, 
							dashboardUrl = formatDashboardUrl(dataItem.name), 
							detailsUrl = controllerBaseUrl + 'Details/' + dataItem.id, 
							exportClickHandler = "MDB.DPN.Campaigns.beginCampaignExport('" + dataItem.id + "')";

						var linkTemplate =
							$(
								'<div class="h-100 text-center">' +
									'<span class="chart-link chart-link-text"></span>' +
									'<span class="chart-link ml-1"><a href="' + dashboardUrl + '" target="_blank"><i class="fas fa-chart-bar" style="color: #72BB53"></i></a></span>' +
									'<span class="chart-link ml-1"><a href="' + detailsUrl + '" target="_blank"><i class="fas fa-external-link-square-alt" style="color: #3379F7"></i></a></span>' +
									'<span class="chart-link ml-1"><a href="javascript:void(0)" onclick="' + exportClickHandler + '"><i class="fa fa-file-pdf" style="color: #E61610"></i></a></span>' +
								'</div>'
							);
						
						linkTemplate.find('.chart-link-text').text(dataItem.name);
						
						return linkTemplate;
					}
				}
			});
		},
		initCampaignEditor: function(selector) {
			addButtonHandlers(selector);
			//Ignore hidden values as not to break validation on kendoMultiselects
			//$(selector).find('form').data("validator").settings.ignore = "";
		},
		initWidgets: function(opts){
			
			opts = $.extend({
				context: document,
				totalsConfig: { },
				timelineConfig: { }
			}, opts);
			
			opts.timelineConfig.url = apiBaseUrl + 'Widget/Timeline'; 
			opts.timelineConfig.annotationUrl = annotationUrl; 
			
			opts.totalsConfig.url = apiBaseUrl + 'Widget/Totals';
			
			var context = $(opts.context); //$(opts.context || document);
			
			var timelineWidget = context.find('#campaigns-timeline-widget'), 
				totalsWidget = context.find('#campaigns-totals-widget');
			
			var loadWidget = function(widget, config, fnRender){
				var loadingDiv = $('<div />', {'class': 'loading'});
				
				widget.empty();
				widget.append(loadingDiv);
				
				return fnRender(widget, config).done(function(){
					loadingDiv.remove();
				});
			};

			var loadTimelineWidget = function(){
				return loadWidget(timelineWidget, opts.timelineConfig, MDB.DPN.Campaigns.initCampaignTimelineWidget);
			};

			var loadTotalsWidget = function(){
				return loadWidget(totalsWidget, opts.totalsConfig, MDB.DPN.Campaigns.initCampaignTotalsWidget);
			};
			
			timelineWidget.data('reload', loadTimelineWidget);
			totalsWidget.data('reload', loadTotalsWidget);
			
			loadTimelineWidget();
			loadTotalsWidget();

			$('.sidebar-toggle').click(function () {
				var widgets = MDB.DPN.Campaigns.getWidgets();

				widgets.forEach(function (widget) {
					setTimeout(function () {
						widget.data('kendoChart').resize();
					}, 500);
				});
			});
		},
		save: function(form, successMessage) {
			var def = $.Deferred();

			var model = form.serializeToJSON();

			MDB.sendAjaxRequest(form.attr('action'), model, form.attr('method'))
			.done(function(response) {
				handleAjaxResponse(response, form, successMessage);
				def.resolve();
			});

			return def.promise();
		},

		//**********Kendo grid buttons**********

		campaignDeleteClick: function (button) {
			var id = $(button).parents('tr').first().children().first().text();

			MDB.promptWithIcon(
				MDB.loadResourceString('Dpn_Campaigns_Index_Remove_Prompt_Title'), 
				MDB.loadResourceString('Dpn_Campaigns_Index_Remove_Prompt_Body'),
				'fa fa-trash-o text-danger', function(ok) {
					if(ok) {
						MDB.sendAjaxRequest(_config.deleteCampaignUrl, {id: id}, 'POST').done(function (response) {
							handleAjaxResponse(response, $('#new-campaign-form'), MDB.loadResourceString('Dpn_Campaigns_Deleted_Successfully_Text'));
							
							_kendo.conceptGrid.dataSource.read().done(function(){
								_kendo.conceptGrid.refresh();
							});
						});
					}
				});
		},
		campaignEditClick: function (button) {
			var title = '<i class="fa fa-pencil text-warning"></i> ' + MDB.loadResourceString('Button_Edit');
			var id = $(button).parents('tr').first().children().first().text();
			var url = _config.editCampaignUrl + '/' + id;

			MDB.DPN.Campaigns.Editor.load(title, url, function() {
				MDB.DPN.Campaigns.Editor.addButton($('<div>').append($('[data-action="campaign-advanced"]').clone()).html());
				MDB.DPN.Campaigns.Editor.addButton($('<div>').append($('[data-action="campaign-concept"]').clone()).html());
				MDB.DPN.Campaigns.initCampaignEditor(_modal);
			});
		},
		campaignDetailsClick: function (button) {
			var id = $(button).parents('tr').first().children().first().text();
			window.location.href = _config.detailsUrl + '/' + id;
		},
		campaignAnnotationClick: function (button) {
			var title = '<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('Button_Add');
			var id = button ? $(button).parents('tr').first().children().first().text() : null;
			
			var url = MDB.DPN.Campaigns.Editor.buildEditorUrl(_config.getEditor, 
				MDB.DPN.Campaigns.Editor.type('CampaignAnnotationModel'), _editorState.create, id);

			MDB.DPN.Campaigns.Editor.load(title, url, null,
			function() {
				MDB.DPN.Campaigns.save($('#new-annotation-form'), 
				MDB.loadResourceString('Dpn_Campaigns_Annotation_Saved_Successfully_Text')).done(function () {
					_kendo.annotationsGrid.dataSource.read().done(function(){
						_kendo.annotationsGrid.refresh();
					});
				});
			});
		},
		annotationDetailsClick: function (button) {
			var model = MDB.KendoConfigBuilder.findGridRowModel(button);
			var id = model.id;
			
			var existing = $('#annotation-details-modal');
			var modal = existing.length === 0 ? MDB.modal() : $('#annotation-details-modal');
			var body = modal.find('.modal-body');
			
			modal.prop('id', 'annotation-details-modal');

			body.append($('<div />', { 'class': 'loading' }));

			body.load('/Campaigns/AnnotationDetails/' + id, function() {

				modal.find('.modal-content').addClass('annotation');
				var type = modal.find('#Type').val();

				var iconClass = 
					type == _annotationType.delivery ? 'fa fa-truck text-success' : 
					(type == _annotationType.change || type == _annotationType.propositionChange) ? 'fa fa-random text-primary' :
					type == _annotationType.attention ? 'fa fa-bell text-warning' : 'fa fa-info text-primary';

				var header = modal.find('.modal-header');
				
				header.html([
					'<h4>',
					'<i class="'+ iconClass +'"></i> ',
						modal.find('#Title').val(),
					'</h4>'
					].join(''));

				header.addClass('annotation');

				modal.on('hidden.bs.modal', function () {
				    header.removeClass(type.toLowerCase());
				    modal.find('.modal-body').empty();
				});

				modal.modal('show');
			});
		},
		campaignDashboardClick: function (button) {
			var model = MDB.KendoConfigBuilder.findGridRowModel(button);
			var url = formatDashboardUrl(model.Name, model.StartDate, model.EndDate);

			window.open(url, '_blank');
		},
		campaignRapportClick: function (button) {
			var me = $(button), 
				row = me.closest('tr[data-uid]'), 
				grid = row.closest('.k-grid');

			var ds = grid.data('kendoGrid').dataSource;
			var model = ds.getByUid(row.data('uid'));

			MDB.DPN.Campaigns.beginCampaignExport(model.id);
		},

		//**********END Kendo Grid buttons**********

		loadTooltip: function (selector, text, opts) {
            if (opts === undefined) {
                opts = {
                    placement: 'bottom'
				};
			}

            selector.tooltip(opts);

            selector.mouseenter(function () {
                selector.attr('data-original-title', text);
                selector.tooltip('show');
            });

            selector.mouseleave(function () {
                selector.tooltip('hide');
            });

            selector.attr('data-original-title', text); 
        },
		beginCampaignExport: function (campaignId){
			var onExportCreationFailed = function(){
				MDB.Notify.errorGrowl('Er is iets misgegaan bij het aanmaken van de export');
			};
	
			var onExportCreationSuccess = function(){
				MDB.Notify.informationGrowl('Export gestart, binnen een paar minuten wordt er een notificatie met download link getoond');
			};
	
			//url, data, method, debug, noErrors
			return MDB.executeWithSignalR(function(con){
				con.TaskHub.server.registerUser.call(this)
					.done(function(){
						MDB.sendAjaxRequest(
							controllerBaseUrl + 'StartExport/' + campaignId,
							undefined,
							'POST',
							false,
							true
						).fail(onExportCreationFailed)
							.done(onExportCreationSuccess);
					})
					.fail(onExportCreationFailed);
			}).fail(onExportCreationFailed);
		}
	});
	
	function formatDashboardUrl(campaignName, startDate, endDate) {
		var dateRange = MDB.DPN.Campaigns.getDateRange();
		
		startDate = startDate == null ?  
			[moment(dateRange.startDate).format('YYYY-MM-DD')] :
	 		[moment(startDate).format('YYYY-MM-DD')];

	 	ednDate = endDate === undefined ?
	 		[moment(dateRange.endDate).format('YYYY-MM-DD')] :
	 		endDate === null ? [moment(new Date('2099-12-31T00:00:00')).format('YYYY-MM-DD')] :
	 		[moment(endDate).format('YYYY-MM-DD')];

		return MDB.Charts.appendFiltersToUrl(
			_config.dashboardUrl,
			[{
				filterId: _config.dashboardNameFilterAttributeId,
				values: [campaignName]
			}, {
				filterId: 'startDate',
				values: startDate
			}, {
				filterId: 'endDate',
				values: ednDate
			}]
		);
	}

	function addButtonHandlers(selector) {
		selector = $(selector);
		var form = selector.find('form');

		selector.find('[data-action="all-titles"]').click(function (e) {
			e.preventDefault();
			MDB.DPN.Campaigns.Editor.kendoListBoxSelectAll(selector.find("#Titles").getKendoMultiSelect());
		});

		selector.find('[data-action="select-atl"]').click(function (e) {
			e.preventDefault();
			MDB.DPN.Campaigns.Editor.kendoListBoxSelectTypeChannels(selector.find("#Channels").getKendoMultiSelect(), 'atl');
		});

		selector.find('[data-action="select-btl"]').click(function (e) {
			e.preventDefault();
			MDB.DPN.Campaigns.Editor.kendoListBoxSelectTypeChannels(selector.find("#Channels").getKendoMultiSelect(), 'btl');
		});

		selector.find('[data-action="campaign-save"]').click(function (e) {
			campaignSaveClick(e, form, _modelState.active);
		});

		selector.find('[data-action="campaign-concept"]').click(function (e) {
			campaignSaveClick(e, form, _modelState.concept);
		});

		selector.find('[data-action="campaign-advanced"]').click(function (e) {
			campaignAdvancedClick(e, form);
		});

		selector.find('[data-action="campaign-details"]').click(function (e) {
			campaignAdvancedClick(e, form);
		});
	}

	function campaignAdvancedClick(e, form) {
		e.preventDefault();
		form.attr('action', _config.advancedUrl);
		form.submit();
	}

	function campaignSaveClick(e, form, state){
		e.preventDefault();
		
		if(state == _modelState.active) {
			saveWithPrompt(form, state);
		} else {
			save(form, state);
		}
	}

	function saveWithPrompt(form, state) {
		MDB.promptWithIcon(
			MDB.loadResourceString('Campaigns_Save_Campaign_Prompt_Title'), 
			MDB.loadResourceString('Campaigns_Save_Campaign_Prompt_Body'), 
			'fa fa-exclamation-triangle text-warning',
			function(ok) {
				if(ok) {
					save(form, state);
				}
			});
	}

	function save(form, state) {
		if(form.valid()) {
			form.find('#State').val(state);

			MDB.DPN.Campaigns.save(form, MDB.loadResourceString('Dpn_Campaigns_Saved_Successfully_Text')).done(function () {
				_kendo.conceptGrid.dataSource.read().done(function(){
					_kendo.conceptGrid.refresh();
				});
				_kendo.pendingGrid.dataSource.read().done(function(){
					_kendo.pendingGrid.refresh();
				});
				_kendo.activeGrid.dataSource.read().done(function(){
					_kendo.activeGrid.refresh();
				});
			});
		}
	}
})();